import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaDetailsDirective} from 'angular-awesome';
import {WaTreeDirective} from 'angular-awesome';
import {WaTreeItemDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-about',
	templateUrl:'./AboutPage.html',
	styles: [],
	styleUrls:['./AboutPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaTagDirective,
		WaCardDirective,
		RouterModule,
		WaButtonDirective,
		MarkdownComponent,
		WaDetailsDirective,
		WaTreeDirective,
		WaTreeItemDirective,
],
	standalone:true
})
export class AboutPage
{
	activeFile = 'tab-ts';
	mdContent_15 = `With the **Angular plugin**, JWebMP turns annotations into a complete Angular application. \`@NgComponent\` creates a component. \`@NgRoutable\` assigns a route. \`@NgDataService\` generates a typed data service. The build produces \`.ts\` files, routing modules, and \`angular.json\` — a production-ready Angular 21 project from Java source alone.`;
	mdContent_16 = `\`\`\`java
@NgComponent("sales-dashboard")
@NgRoutable(path = "dashboard")
public class SalesDashboard
    extends DivSimple<SalesDashboard>
    implements INgComponent<SalesDashboard> {

  public SalesDashboard() {
    add(new SampleSalesGrid());
    add(new SampleRevenueChart());
  }
}

// ── Grid definition ──
@NgComponent("sample-sales-grid")
public class SampleSalesGrid
    extends AgGrid<SampleSalesGrid> {

  public SampleSalesGrid() {
    setID("salesGrid");
    addColumnDef(new AgGridColumnDef<>()
      .setField("region")
      .setHeaderName("Region")
      .setFilter(true).setSortable(true));
    addColumnDef(new AgGridColumnDef<>()
      .setField("product")
      .setHeaderName("Product")
      .setFilter(true).setSortable(true));
    addColumnDef(new AgGridColumnDef<>()
      .setField("units")
      .setHeaderName("Units Sold")
      .setSortable(true));
    addColumnDef(new AgGridColumnDef<>()
      .setField("revenue")
      .setHeaderName("Revenue")
      .setSortable(true));
    addColumnDef(new AgGridColumnDef<>()
      .setField("profit")
      .setHeaderName("Profit")
      .setSortable(true));
  }

  @Override
  public Collection fetchData() {
    return List.of();
  }
}
\`\`\``;
	mdContent_17 = `\`\`\`typescript
import {Component} from '@angular/core';
import {SampleSalesGrid} from
  '../SampleSalesGrid/SampleSalesGrid';
import {SampleRevenueChart} from
  '../SampleRevenueChart/SampleRevenueChart';
import {inject} from '@angular/core';

@Component({
  selector: 'sales-dashboard',
  templateUrl: './SalesDashboard.html',
  styleUrls: ['./SalesDashboard.scss'],
  imports: [
    SampleSalesGrid,
    SampleRevenueChart,
  ],
  standalone: true
})
export class SalesDashboard {
  readonly sampleSalesGrid =
    inject(SampleSalesGrid);
  readonly sampleRevenueChart =
    inject(SampleRevenueChart);
}
\`\`\``;
	mdContent_18 = `\`\`\`html
<div>
	<sample-sales-grid></sample-sales-grid>
	<sample-revenue-chart></sample-revenue-chart>
</div>
\`\`\``;
	mdContent_19 = `\`\`\`typescript
import {OnDestroy, AfterViewInit, ViewChild,
  HostListener, Component} from '@angular/core';
import {AgGridAngular} from 'ag-grid-angular';
import {ColDef, ColGroupDef, GridApi, GridOptions,
  GetRowIdFunc, GetRowIdParams,
  RowSelectedEvent} from 'ag-grid-community';
import {Subscription} from 'rxjs';
import {v4 as uuidv4} from 'uuid';
import {EventBusService} from
  '…/services/EventBusService/EventBusService';
import {inject} from '@angular/core';

@Component({
  selector: 'sample-sales-grid',
  templateUrl: './SampleSalesGrid.html',
  styleUrls: ['./SampleSalesGrid.scss'],
  imports: [AgGridAngular],
  standalone: true
})
export class SampleSalesGrid
    implements OnDestroy, AfterViewInit {
  readonly eventBusService =
    inject(EventBusService);
  readonly subscription?: Subscription;
  readonly handlerId: string;
  readonly datasetHandlerId: string;
  gridApi?: GridApi;
  columnDefs: (ColDef | ColGroupDef)[] = [
    {field:'region',  headerName:'Region',
     sortable:true, filter:true},
    {field:'product', headerName:'Product',
     sortable:true, filter:true},
    {field:'units',   headerName:'Units Sold',
     sortable:true},
    {field:'revenue', headerName:'Revenue',
     sortable:true},
    {field:'profit',  headerName:'Profit',
     sortable:true}
  ];
  getRowId: GetRowIdFunc =
    (p: GetRowIdParams) =>
      String(p.data.region);
  defaultColDef: ColDef = {
    sortable: true, filter: true,
    resizable: true
  };
  @ViewChild('salesGrid')
  salesGrid?: AgGridAngular;
  options: GridOptions = {};
  readonly listenerName = 'salesGrid';

  constructor() {
    this.datasetHandlerId =
      this.generateHandlerId();
    this.handlerId =
      this.generateHandlerId();
    this.subscription = this.eventBusService
      .listen(this.listenerName, this.handlerId)
      .subscribe({
        next: (message: any) => {
          // … parse rows and update grid …
        },
        error: (e) => console.log(e),
      });
  }
  ngAfterViewInit() {
    this.eventBusService.send(
      this.listenerName,
      { className: this.clazzName,
        listenerName: this.listenerName },
      this.listenerName);
  }
  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.onSizeColumnsToFit();
  }
  onSizeColumnsToFit(): void {
    if (this.gridApi) {
      setTimeout(() =>
        this.gridApi?.sizeColumnsToFit(), 0);
    }
  }
  @HostListener('window:resize')
  onWindowResize(): void {
    this.onSizeColumnsToFit();
  }
  ngOnDestroy() {
    this.eventBusService.unregisterListener(
      this.listenerName, this.handlerId);
  }
}
\`\`\``;
	mdContent_20 = `\`\`\`html
<ag-grid-angular #salesGrid
  (firstDataRendered)="onFirstDataRendered()"
  (gridReady)="onGridReady($event)"
  (gridSizeChanged)="onGridSizeChanged()"
  [columnDefs]="columnDefs"
  [context]="{ componentParent: this }"
  [defaultColDef]="defaultColDef"
  [getRowId]="getRowId"
  [gridOptions]="options"
  id="salesGrid"
  style="width: 100%; height: 500px;">
</ag-grid-angular>
\`\`\``;
	mdContent_21 = `\`\`\`typescript
import {OnDestroy, AfterViewInit, Component,
  signal, computed} from '@angular/core';
import {AgCharts} from 'ag-charts-angular';
import {Subscription} from 'rxjs';
import {v4 as uuidv4} from 'uuid';
import {EventBusService} from
  '…/services/EventBusService/EventBusService';
import {inject} from '@angular/core';

@Component({
  selector: 'sample-revenue-chart',
  templateUrl: './SampleRevenueChart.html',
  styles: [\`:host { display: block;
    position: relative;
    width:100%; height:100% }\`],
  styleUrls: ['./SampleRevenueChart.scss'],
  imports: [AgCharts],
  standalone: true
})
export class SampleRevenueChart
    implements OnDestroy, AfterViewInit {
  readonly eventBusService =
    inject(EventBusService);
  readonly chartOptions =
    signal<any | undefined>(undefined);
  readonly handlerId: string;
  private subscriptionOptions?: Subscription;
  private subscriptionData?: Subscription;
  chartData: any;
  readonly chartReady =
    computed(() => !!this.chartOptions());
  readonly listenerName = 'revenueChart';

  constructor() {
    this.handlerId =
      this.generateHandlerId();
  }
  ngAfterViewInit() {
    this.initializeOptionsListener();
    this.initializeDataListener();
    this.fetchOptions();
    this.fetchDataChannel();
  }
  initializeOptionsListener() {
    this.subscriptionOptions =
      this.eventBusService
        .listen(this.listenerName + 'Options',
               this.handlerId)
        .subscribe({
          next: (data) =>
            this.handleOptionsEvent(data),
        });
  }
  handleOptionsEvent(data: any) {
    const payload = typeof data === 'string'
      ? JSON.parse(data) : data;
    const options = payload?.out?.[0]
      ?? payload;
    this.chartOptions.set(options);
  }
  // … fetchOptions, data listeners …
  ngOnDestroy() {
    this.subscriptionOptions?.unsubscribe();
    this.subscriptionData?.unsubscribe();
  }
}
\`\`\``;
	mdContent_22 = `\`\`\`html
@if (chartReady() && chartOptions()) {
	<ag-charts [options]="chartOptions()"
	           id="revenueChart">
	</ag-charts>
}
\`\`\``;
	mdContent_23 = `\`\`\`typescript
import {Routes} from '@angular/router';
import {SalesDashboard} from
  './sales-dashboard/SalesDashboard';

export const routes: Routes = [
  {
    path: 'dashboard',
    component: SalesDashboard
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];
\`\`\``;
	mdContent_24 = `**Hosted mode** gives you 50+ server-driven AJAX events, REST endpoints, and Vert.x WebSocket broadcasting out of the box. **Angular mode** generates typed \`@NgDataService\` classes and connects to the Vert.x STOMP event bus for live data. Need durability? Add RabbitMQ Comms for broker-backed messaging.`;
	mdContent_25 = `\`\`\`java
@Path("/api/sales") @GET
public List<SalesRow> getSales() { return service.findAll(); }
\`\`\``;
	mdContent_26 = `\`\`\`java
StompEventBusPublisher.publish(vertx, "dashboard", jsonPayload);
// or: publisher.publish("user-" + userId, payload); // RabbitMQ
\`\`\``;
	onFileTreeSelect($event: any) {
	    const selection = $event?.detail?.selection;
	    if (selection && selection.length > 0) {
	        const panel = selection[0].getAttribute('data-panel');
	        if (panel) { this.activeFile = panel; }
	    }
	}

}
